import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=d21b3bc4&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=d21b3bc4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21b3bc4"]])

export default __exports__